export default __webpack_public_path__ + "static/background-8-442a8a5148a8694165e445605284b334.png";